import { render, staticRenderFns } from "./SyncStepsButton.vue?vue&type=template&id=3cce735c&"
import script from "./SyncStepsButton.vue?vue&type=script&lang=js&"
export * from "./SyncStepsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports